var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdownContainerR2"},[_c('markdown-it-vue',{staticClass:"markdownTag",attrs:{"content":_vm.resultFormula}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }